/* * Version: 3.3.0
 * Letzte Änderung: 18.09.2026, 15:09
 * Änderungshistorie: Route für die neue Benutzerverwaltung (UserManagementScreen) im ProtectedRoute-Block hinzugefügt.
 * Copyright: BAIT-Tech
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from './components/Header';
import ClubScreen from './screens/ClubScreen';
import PlayerScreen from './screens/PlayerScreen';
import TournamentScreen from './screens/TournamentScreen';
import TournamentDetailScreen from './screens/TournamentDetailScreen';
import ScheduleScreen from './screens/ScheduleScreen';
import ResultsScreen from './screens/ResultsScreen';
import StreamerViewScreen from './screens/StreamerViewScreen';
import FinanceScreen from './screens/FinanceScreen';
import StatisticsScreen from './screens/StatisticsScreen';
import HelpScreen from './screens/HelpScreen';
import TrophyScreen from './screens/TrophyScreen';
import CertificateScreen from './screens/CertificateScreen';
import TemplateListScreen from './screens/TemplateListScreen';
import TemplateDesignerScreen from './screens/TemplateDesignerScreen';
import TabletScoreScreen from './screens/TabletScoreScreen';
import BracketScreen from './screens/BracketScreen';
import BracketManagerScreen from './screens/BracketManagerScreen';
import UserManagementScreen from './screens/UserManagementScreen'; // NEU

// Importe für das Sicherheitskonzept & die öffentliche Lobby
import LoginScreen from './screens/LoginScreen';
import ProtectedRoute from './components/ProtectedRoute';
import PublicTournamentListScreen from './screens/PublicTournamentListScreen';
import { AuthProvider } from './context/AuthContext';

const AppLayout = () => {
  const location = useLocation();
  const isTabletView = location.pathname.includes('/tablet');
  const isStreamerView = location.pathname.includes('/stream');
  
  // Subdomain-Erkennung
  const isStartplanSubdomain = window.location.hostname.startsWith('startplan');

  // Der Header wird ausgeblendet, wenn wir auf der Startplan-Subdomain, im Tablet- oder im Stream-Modus sind
  const isHeaderHidden = isTabletView || isStreamerView || isStartplanSubdomain;
  const mainClassName = isTabletView ? 'main-full-width' : '';

  return (
    <>
      {!isHeaderHidden && <Header />}
      <main className={mainClassName}>
        <Routes>
          {/* =====================================================================
              ÖFFENTLICHE ROUTEN (Ohne Login erreichbar)
              ===================================================================== */}
          <Route path="/login" element={<LoginScreen />} />
          
          {/* Bedingtes Routing für die Startseite ("/") */}
          {isStartplanSubdomain && <Route path="/" element={<PublicTournamentListScreen />} />}
          
          <Route path="/turnier/:id/startplan" element={<ScheduleScreen />} />
          <Route path="/turnier/:id/ergebnisse" element={<ResultsScreen />} />
          <Route path="/turnier/:id/bracket/:gameMode/:classification" element={<BracketScreen />} />
          <Route path="/turnier/:tournamentId/stream/:classificationKey" element={<StreamerViewScreen />} />
          
          {/* =====================================================================
              GESCHÜTZTE ROUTEN (Benötigen zwingend den Administrator-Login)
              ===================================================================== */}
          <Route element={<ProtectedRoute />}>
            {!isStartplanSubdomain && <Route path="/" element={<TournamentScreen />} />}
            
            <Route path="/turnier/:id" element={<TournamentDetailScreen />} />
            <Route path="/turnier/:id/ko-manager/:gameMode" element={<BracketManagerScreen />} />
            <Route path="/turnier/:id/finanzen" element={<FinanceScreen />} />
            <Route path="/turnier/:id/statistik" element={<StatisticsScreen />} />
            <Route path="/turnier/:id/pokale" element={<TrophyScreen />} />
            <Route path="/turnier/:id/urkunden" element={<CertificateScreen />} />
            <Route path="/turnier/:id/tablet" element={<TabletScoreScreen />} />
            <Route path="/vereine" element={<ClubScreen />} />
            <Route path="/spieler" element={<PlayerScreen />} />
            <Route path="/vorlagen" element={<TemplateListScreen />} />
            <Route path="/vorlagen/:id" element={<TemplateDesignerScreen />} />
            <Route path="/hilfe" element={<HelpScreen />} />
            <Route path="/benutzer" element={<UserManagementScreen />} /> {/* NEU */}
          </Route>
        </Routes>
      </main>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer
          position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false}
          closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored"
        />
        <AppLayout />
      </Router>
    </AuthProvider>
  );
}

export default App;